module.exports = __webpack_public_path__ + "img/cols2.7cb0eeaa.png";